module.exports = __webpack_public_path__ + "img/save.ca50d783.svg";